export const getFeedbackPreview = async (postProcessUuid, signal = null) => {
  if (!postProcessUuid) {
    throw new Error('postProcessUuid is required to fetch feedback preview');
  }

  const baseUrl = process.env.REACT_APP_BASE_URL;

  const url = `${baseUrl}/api/v1/project/get_feedback_preview/?post_process_uuid=${
    encodeURIComponent(postProcessUuid)}`;

  const response = await fetch(url, signal ? { signal } : {});

  if (!response.ok) {
    throw new Error(`Failed to fetch feedback preview: ${response.status} ${response.statusText}`);
  }

  const data = await response.json();

  return data;
};

// Returns a presigned S3 URL for the given object key. Fetching S3 directly avoids
// CloudFront, whose cached copies are missing CORS headers.
export const getS3ObjectUrl = async fileKey => {
  if (!fileKey) {
    throw new Error('fileKey is required to fetch a download URL');
  }

  const baseUrl = process.env.REACT_APP_BASE_URL;

  const url = `${baseUrl}/api/v1/project/get_s3_object_url/?file_key=${
    encodeURIComponent(fileKey)}`;

  const response = await fetch(url);

  if (!response.ok) {
    throw new Error(`Failed to fetch download URL: ${response.status} ${response.statusText}`);
  }

  const data = await response.json();

  return data.download_url;
};

export default getFeedbackPreview;
